import { z } from "zod";
import { DocumentReference } from "@atgof-firebase/types";

export const reference = z.custom<DocumentReference>(
  (val) =>
    val &&
    typeof val === "object" &&
    "id" in val &&
    "firestore" in val &&
    "path" in val,
);
